import type { ReactNode } from 'react'
import Group from 'components/utils/Group'
import PriceRowValueDiscount from 'LuxKit/PricePoints/Value/PriceRowValueDiscount'
import UrgencyLabel from 'LuxKit/Label/UrgencyLabel'
import SecureWithDepositTagAndModal from 'components/Common/SecureWithDeposit/SecureWithDepositTagAndModal'
import Clickable from 'components/Common/Clickable/Clickable'
import Pill from 'LuxKit/Pill'
import LineClockDollarIcon from 'LuxKit/Icons/line/LineClockDollarIcon'
import type { getDiscountPillVisibilityFlags } from './flashHotelDiscountPillVisibilityUtils'

interface Props {
  discountPillVisibility: ReturnType<typeof getDiscountPillVisibilityFlags>
  roomsBeforeSurcharge?: number
  discountPercent?: number
  roomsRemainingLabel?: string
  flexiblePaymentLabel?: string
  showDepositTag: boolean
  isFlexibleCancellation: boolean
  offer: App.Offer
  depositAmountPercentage: number
  showFlexiblePaymentTag: boolean
  onFlexPaymentPolicyOpen: () => Promise<void>
  priceContent: ReactNode
}

function FlashHotelOptionPriceDetailsContent(props: Props) {
  const {
    discountPillVisibility,
    roomsBeforeSurcharge,
    discountPercent,
    roomsRemainingLabel,
    flexiblePaymentLabel,
    showDepositTag,
    isFlexibleCancellation,
    offer,
    depositAmountPercentage,
    showFlexiblePaymentTag,
    onFlexPaymentPolicyOpen,
    priceContent,
  } = props

  return <>
    <Group direction="horizontal" gap={8} wrap="wrap" noDisplayWhenEmpty>
      {discountPillVisibility.topDiscountPillVisible && !roomsBeforeSurcharge && !!discountPercent && <PriceRowValueDiscount
        type="estimate"
        discountPercentage={discountPercent}
      />}
      {!!roomsBeforeSurcharge &&
        <UrgencyLabel variant="speed">
          {roomsRemainingLabel}
        </UrgencyLabel>}
      {showDepositTag && <SecureWithDepositTagAndModal
        isFlexibleCancellation={isFlexibleCancellation}
        offerType={offer.type}
        depositAmountPercentage={depositAmountPercentage}
        depositThresholds={offer.depositThresholds}
      />}
      {showFlexiblePaymentTag && <Clickable onClick={onFlexPaymentPolicyOpen}>
        <Pill startIcon={<LineClockDollarIcon />}>
          {flexiblePaymentLabel}
        </Pill>
      </Clickable>}
    </Group>
    {priceContent}
  </>
}

export default FlashHotelOptionPriceDetailsContent
